import baseURL from "@/api/baseURL";
export function getBaseUrl(){
  return process.env.NODE_ENV === "development" ? baseURL : URLCONFIG.baseUrl;
}